<template>
  <div id="app">
    <div>
      <div class="login_maxBox">
        <div class="container login_box center-block regist">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            class="fifth table-list"
          >
            <el-tab-pane label="Email" name="first" class="ten">
              <el-form
                ref="form"
                :model="form"
                label-width="80px"
                class="twenfive"
              >
                <el-form-item label="Email:">
                  <el-col :lg="14" :xl="12" :md="12" :sm="12">
                    <el-input
                      v-model="form.name"
                      placeholder="Please input E-mail"
                      @blur="DetectInput($event, 'emails')"
                      @input="DetectKey($event, 'emails')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="6"
                    class="leftfloat ml1 myzm"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="sendCodeBtn"
                      v-html="this.Btn"
                      title="Send verification code"
                    ></el-button>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    The system is for script process system, Input your
                    frequently-used Email box .
                  </div>
                  <div class="clearfix"></div>
                  <div class="twenfive">
                    <div class="msg_error" v-html="EmailTiShi"></div>
                    <el-button
                      class="five"
                      style="width: 100%"
                      v-if="status == 0"
                      @click="$router.push('/')"
                      >Cancel</el-button
                    >
                  </div>
                  <div class="twenfive">
                    <div class="msg_error" v-if="statuCf">
                      The email have been registered. If the email is your email
                      confidently.
                      <a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >You can input Verification code to retrieve</a
                      >
                    </div>
                    <div class="highgreen" v-if="status == 1">
                      Verification code is sent, confirm in 24 hours.
                    </div>
                  </div>
                </el-form-item>
                <template v-if="status == 1">
                  <el-form-item label="V code:" title="verification code:">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcode"
                        placeholder="Please input verification code"
                      ></el-input>
                      <div class="msg_error" v-html="codeTishi"></div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Password:">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.pass"
                        placeholder="Please input Password"
                        @blur="DetectInput($event, 'pass')"
                        @input="DetectKey($event, 'pass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="Password:" title="confirm password">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.rpass"
                        placeholder="Enter Password Again"
                        @blur="DetectInput($event, 'rpass')"
                        @input="DetectKey($event, 'rpass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button
                      style="width: 48%"
                      type="primary"
                      @click="submit()"
                      >Submit</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >Cancel</el-button
                    >
                    <div class="highgreen ten" v-if="showsuess">
                      <i class="el-icon-success"></i>Submitted successfully！
                      <a href="javascript:;" class="highblue ml15"
                        >After logging in and fulfilling personal information,
                        then contribute.</a
                      >
                    </div>
                  </el-form-item>
                </template>
              </el-form>
            </el-tab-pane>

            <el-tab-pane
              label="Mobile"
              name="second"
              class="ten"
              v-if="isphones"
            >
              <el-form
                ref="form"
                :model="form"
                label-width="80px"
                class="twenfive"
              >
                <el-form-item label="Mobile:">
                  <el-col :md="14" :lg="14" :xl="14" :sm="12">
                    <el-input
                      v-model="form.name"
                      placeholder="Please input Mobile"
                      @blur="DetectInput($event, 'phone')"
                      @input="DetectKey($event, 'phone')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="6"
                    class="leftfloat ml1 myzm"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="sendCodeBtn"
                      v-html="Btn"
                      title="Send verification code"
                    ></el-button>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    The system is for script process system, Input your
                    frequently-used mobile number .
                  </div>
                  <div class="clearfix"></div>
                  <div class="twenfive">
                    <div class="msg_error" v-html="phoneTiShi"></div>
                    <el-button
                      class="five"
                      style="width: 100%"
                      v-if="status == 0"
                      @click="$router.push('/')"
                      >Cancel</el-button
                    >
                  </div>
                  <div class="twenfive">
                    <div class="msg_error" v-if="statuCf">
                      The Mobile have been registered. If the mobile is your
                      mobile confidently.
                      <a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >You can input Verification code to retrieve</a
                      >
                    </div>
                    <div class="highgreen" v-if="status == 1">
                      Verification code is sent, confirm in 10 minites.
                    </div>
                  </div>
                </el-form-item>
                <template v-if="status == 1">
                  <el-form-item label="V Code:" title="Verification code">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcode"
                        placeholder="Please input Verification code"
                      ></el-input>
                      <div class="msg_error" v-html="codeTishi"></div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Password:">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.pass"
                        placeholder="Please input Password"
                        @blur="DetectInput($event, 'pass')"
                        @input="DetectKey($event, 'pass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="Password:" title="confirm password">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.rpass"
                        placeholder="Enter Password Again"
                        @blur="DetectInput($event, 'rpass')"
                        @input="DetectKey($event, 'rpass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button
                      style="width: 48%"
                      type="primary"
                      @click="submit()"
                      >Submit</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >Cancel</el-button
                    >
                    <div class="highgreen ten" v-if="showsuess">
                      <i class="el-icon-success"></i>Submitted successfully！
                      <a href="javascript:;" class="highblue ml15"
                        >After logging in and fulfilling personal information,
                        then contribute.</a
                      >
                    </div>
                  </el-form-item>
                </template>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="Username" name="third" class="ten">
              <el-form
                ref="form"
                :model="form"
                label-width="80px"
                class="twenfive"
              >
                <el-form-item label="Username:">
                  <el-col :md="10" :lg="10" :xl="10" :sm="10">
                    <el-input
                      v-model="form.user"
                      placeholder="Please input Username"
                      @blur="DetectInput($event, 'user')"
                      @input="DetectKey($event, 'user')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="8"
                    class="leftfloat ml1 myzm"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="sendCodeBtn($event, 'phone')"
                      >Available?</el-button
                    >
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    4-16 characters. Only Digit,alphabet,Underline. All digits
                    is prohibited.
                  </div>
                  <div class="highgreen" v-if="stat == 1">
                    The username is avaiable.
                  </div>
                  <div class="msg_error" v-html="userTishi"></div>
                </el-form-item>
                <el-form-item label="Email:">
                  <el-col :md="14" :lg="14" :xl="14" :sm="12">
                    <el-input
                      v-model="form.name"
                      placeholder="Please input E-mail"
                      @blur="DetectInput($event, 'emails')"
                      @input="DetectKey($event, 'emails')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="6"
                    class="leftfloat ml1 myzm"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="sendCodeBtn"
                      v-html="Btn"
                      title="Send verification code"
                    ></el-button>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    The system is for script process system, Input your
                    frequently-used Email box .
                  </div>
                  <div class="clearfix"></div>
                  <div class="twenfive">
                    <div class="msg_error" v-html="EmailTiShi"></div>
                    <el-button
                      class="five"
                      style="width: 100%"
                      v-if="status == 0"
                      @click="$router.push('/')"
                      >Cancel</el-button
                    >
                  </div>
                  <div class="twenfive">
                    <div class="msg_error" v-if="statuCf">
                      The email have been registered. If the email is your email
                      confidently.<a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >You can input Verification code to retrieve</a
                      >
                    </div>
                    <div class="highgreen" v-if="status == 1">
                      Verification code is sent, confirm in 24 hours.
                    </div>
                  </div>
                </el-form-item>
                <template v-if="status == 1">
                  <el-form-item label="V Code:" title="Verification code">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcode"
                        placeholder="Please input verification code"
                      ></el-input>
                      <div class="msg_error" v-html="codeTishi"></div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Password:">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.pass"
                        placeholder="Please input Password"
                        @blur="DetectInput($event, 'pass')"
                        @input="DetectKey($event, 'pass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="Password:" title="confirm password">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.rpass"
                        placeholder="Enter Password Again"
                        @blur="DetectInput($event, 'rpass')"
                        @input="DetectKey($event, 'rpass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button
                      style="width: 48%"
                      type="primary"
                      @click="submit()"
                      >Submit</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >Cancel</el-button
                    >
                    <div class="highgreen ten" v-if="showsuess">
                      <i class="el-icon-success"></i>Submitted successfully！
                      <a href="javascript:;" class="highblue ml15"
                        >After logging in and fulfilling personal information,
                        then contribute.</a
                      >
                    </div>
                  </el-form-item>
                </template>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>

        <p class="text-center" style="color: #2d73c6">
          QQ<span v-if="isweixin">、WeChat，</span>can login directly，No
          registration required.
        </p>
        <div class="clearfix"></div>
        <div class="login_other_button">
          <!-- <div class="weixin" onclick="this.className = 'weixin on';"> -->
          <el-button
            v-if="isweixin"
            text
            @click="wxshow()"
            class="weixin"
            ><img src="../../assets/images/add_wx1.png"
          /></el-button>
          <!-- <a href="javascript:;"><img   @mouseenter="wxshow()" src="../../assets/images/add_wx1.png"></a> -->
          <el-dialog
            v-model="dialogVisible"
            width=""
            center
            :before-close="handleClose"
            class="wxcode"
          >
            <div v-loading="loading">
              <p class="mobList eqcode">
                Long press the identification QR code to register and log in
              </p>
              <p class="pclist eqcode">
                Please use wechat to scan QR code to register and log in
              </p>
              <!-- <Login_WeiXin
  				 @func="getMsgFormSon" style="display:block;margin:0 auto"
  				 @fuab="dialoga"
  				 :dialogVisible='dialogVisible'
  				 :type="1"
  				></Login_WeiXin> -->
              <div>
                <img :src="src" width="150" height="150" style="" />
              </div>
            </div>
          </el-dialog>
          <!-- <div class="weixin_nr" v-if="showWx" > -->
          <!-- <img src="../../assets/images/weixin.jpg" width="150" height="150" />
                  <Login_WeiXin
  				 @func="getMsgFormSon"
  				></Login_WeiXin> -->
          <!-- </div> -->
          <a style="cursor: pointer" @click="useqqlogin" class="qq_login"
            ><img src="../../assets/images/add_qq1.png"
          /></a>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="hint"
    >
      <div style="text-align: center">
        <p>
          Your password does not meet relevant requirements,Please<router-link
            to="/ChangePassword"
            style="color: red"
            >click here</router-link
          >to change your password.
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
var timeStop
import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
import Login_WeiXin from '../../components/Login/Login_WeiXin'
var time
export default {
  name: 'reg',
  data() {
    return {
      statuCf: false,
      showWx: false,
      activeName: 'first',
      isweixin: true,
      dialogVisible: false,
      Code: '',
      src: '',
      form: {
        name: '',
        yzcode: '',
        pass: '',
        rpass: '',
        user: '',
      },
      type: 2,
      types: 0,
      model: '',
      isweixin: true,
      fixmodel: 'EmailBox',
      dialogVisible: false,
      loading: true,
      phoneTiShi: '',
      pwdTiShi: '',
      rpwdTiShi: '',
      EmailTiShi: '',
      codeTishi: '',
      userTishi: '',
      Btn: 'Send code',
      wait: 60,
      user_type: '',
      status: 0,
      isphones: false,
      GUID: '',
      stat: 0,
      showsuess: false,
      isphone: false,
      pwdFalseShow: false,
    }
  },
  components: {
    Login_WeiXin,
  },
  created() {
    this.initVeri()

    if (sessionStorage.getItem('SetItem')) {
      let SetItem = JSON.parse(sessionStorage.getItem('SetItem'))
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == '是') {
            this.isphone = true
          } else {
            this.isphone = false
          }
        }
        if (item.SetItemID == 2960) {
          if (item.Item_Value == '是') {
            this.isweixin = true
          } else {
            this.isweixin = false
          }
        }
        if (item.SetItemID == 12) {
          if (item.Item_Value == '是') {
            this.isphones = true
          } else {
            this.isphones = false
          }
        }
      })
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        6021, 6022,
      ]
      this.$store.dispatch('_getSet', params).then((res) => {
        sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
        let SetItem = res.data.Data
        SetItem.map((item) => {
          if (item.SetItemID == 11) {
            if (item.Item_Value == '是') {
              this.isphone = true
            } else {
              this.isphone = false
            }
          }
          if (item.SetItemID == 2960) {
            if (item.Item_Value == '是') {
              this.isweixin = true
            } else {
              this.isweixin = false
            }
          }
        })
      })
    }
  },
  methods: {
    async wxshow() {
      this.dialogVisible = true
      let carousel = await this.$store.dispatch('_getGetQrcode')
      if (carousel) {
        this.src = carousel.data.Url
        this.Code = carousel.data.Code
        this.loading = false
        this.handleQrcodeCheck(this.type)
        $emit(this, 'func', this.src)
      }
    },
    handleQrcodeCheck(type) {
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch('_getWeiXinLogin', { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true
                return
              }
              this.$message({ message: 'Success!', type: 'success' })
              localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
              var urldomain = '/'
              window.location.href = urldomain
              $emit(this, 'fuab', false)
            }
          })
      }, 2000)
    },
    handleClose(done) {
      done()
      this.dialogVisible = false
      clearInterval(timeStop)
    },
    //点击QQ登录
    // tz() {
    // 	var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101866331&response_type=token&scope=all&redirect_uri=http:/2020test.notefirst.com/login_qq";
    // 	window.location.href = urldz;
    // },
    useqqlogin() {
      // this.$router.push("/login_qq")
      // let redirect = "http://2020test.notefirst.com"
      // this.Openkind ="QQ"
      // QC.Login.showPopup({//打开QQ授权登录界面，授权成功后会重定向
      // appId:"101871016",
      // redirectURI:"http://2020test.notefirst.com/#/login_qq",//登录成功后会自动跳往该地址
      // });
      var urldz =
        'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=' +
        window.OpenId +
        '&response_type=token&scope=all&redirect_uri=http%3A%2F%2F' +
        window.callBackHtp +
        '%2F%23%2Flogin_qq'
      window.location.href = urldz
    },
    handleClick(tab, event) {
      if (this.isphones) {
        if (tab.index == 0) {
          this.type = 2
          this.types = 0
          this.model = 'EmailBox'
        } else if (tab.index == 1) {
          this.type = 3
          this.types = 2
          this.model = 'Mobile'
        } else {
          this.type = 1
          this.types = 0
          this.model = 'UserName'
        }
      } else {
        if (tab.index == 0) {
          this.type = 2
          this.types = 0
          this.model = 'EmailBox'
        } else {
          this.type = 1
          this.types = 0
          this.model = 'UserName'
        }
      }
      this.form = {
        name: '',
        yzcode: '',
        pass: '',
        rpass: '',
        user: '',
      }
      this.phoneTiShi = ''
      this.pwdTiShi = ''
      this.rpwdTiShi = ''
      this.EmailTiShi = ''
      this.codeTishi = ''
      this.userTishi = ''
      this.Btn = 'Send code'
      this.wait = 60
      this.user_type = ''
      this.status = 0
      this.stat = 0
      clearInterval(time)
    },
    getMsgFormSon(data) {
      this.loading = false
      this.wx = data
    },
    dialoga(data) {
      this.dialogVisible = false
    },

    //鼠标离开
    DetectInput(elem, type) {
      console.log(type)
      //焦点离开时候的事件
      if (type == 'emails') {
        if (this.$Bai(elem.target.value)) {
          return (this.EmailTiShi = 'Please input email')
        }
        if (this.$Space(elem.target.value)) {
          return (this.EmailTiShi = 'Mailbox cannot contain spaces')
        }
        if (!this.$base(elem.target.value, 'email')) {
          return (this.EmailTiShi = 'Please enter the correct email format')
        } else {
          return (this.EmailTiShi = '')
        }
      }
      if (type == 'phone') {
        if (this.$Bai(elem.target.value)) {
          return (this.phoneTiShi = 'Please enter the phone number')
        }
        if (this.$Space(elem.target.value)) {
          return (this.phoneTiShi = 'Mobile phone number cannot contain spaces')
        }
        if (!this.$base(elem.target.value, 'phone')) {
          return (this.phoneTiShi =
            'Please enter the phone number in the correct format')
        } else {
          return (this.phoneTiShi = '')
        }
      }
      if (type == 'pass') {
        if (this.$Bai(elem.target.value)) {
          return (this.pwdTiShi = 'password can not be blank')
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi =
            'Password cannot be less than eight characters')
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = 'Password cannot contain spaces')
        } else if (this.$base(elem.target.value, 'aff')) {
          return (this.pwdTiShi = 'Illegal characters found in password')
        } else if (!this.$base(elem.target.value, 'pass')) {
          return (this.pwdTiShi =
            'The password must be set to 8~16 letters, numbers and special characters .!@#_ Combination')
        } else {
          this.pwdTiShi = ''
        }
      }
      if (type == 'rpwd') {
        if (this.$Bai(elem.target.value)) {
          this.rpwdTiShi = 'Password can not be blank'
        } else if (elem.target.value.length < 8) {
          this.rpwdTiShi = 'Password cannot be less than eight characters'
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = 'Password cannot contain spaces')
        } else if (this.form.pass != this.form.rpass) {
          this.rpwdTiShi = 'The two passwords are not the same'
        } else {
          this.rpwdTiShi = ''
        }
      }
      if (type == 'user') {
        if (this.$Bai(elem.target.value)) {
          this.userTishi = 'Account cannot be empty'
        } else if (!this.$base(elem.target.value, 'name')) {
          this.userTishi = 'Illegal characters found in username'
        } else if (!isNaN(elem.target.value)) {
          this.userTishi = 'Illegal characters found in username'
        } else {
          this.userTishi = ''
        }
      }
    },
    DetectKey(elem, type) {
      let base = this.base
      if (type == 'phone') {
        this.statuCf = false
        return (this.phoneTiShi = '')
      } else if (type == 'code') {
        this.statuCf = false
        return (this.codeTiShi1 = '')
      } else if (type == 'pwd') {
        this.statuCf = false
        return (this.pwdTiShi = '')
      } else if (type == 'rpwd') {
        this.statuCf = false
        return (this.rpwdTiShi = '')
      } else {
        this.statuCf = false
        return (this.EmailTiShi = '')
      }
    },
    async sendCodeBtn(elem, str) {
      //点击发送验证码
      //0: Email 1:用户名 2: 手机
      let Type = this.types
      let name = ''
      let names = ''
      var numerr = 0
      names = this.form.user
      if (str == 'phone') {
        name = this.form.user
        Type = 1
        if (this.$Bai(name)) {
          numerr = 1
          this.stat = 0
          return (this.userTishi = 'Account cannot be empty')
        } else if (!this.$base(name, 'name')) {
          numerr = 1
          this.stat = 0
          return (this.userTishi = 'Illegal characters found in username')
        } else if (!isNaN(name)) {
          numerr = 1
          this.stat = 0
          return (this.userTishi = 'Illegal characters found in username')
        } else {
          this.userTishi = ''
          this.stat = 1
          numerr = 0
        }
      } else {
        name = this.form.name
        if (this.types == 0) {
          if (this.type == 1) {
            if (this.$Bai(names)) {
              numerr = 1
              this.stat = 0
              return (this.userTishi = 'Account cannot be empty')
            } else if (!this.$base(names, 'name')) {
              numerr = 1
              this.stat = 0
              return (this.userTishi = 'Illegal characters found in username')
            } else if (!isNaN(names)) {
              numerr = 1
              this.stat = 0
              return (this.userTishi = 'Illegal characters found in username')
            } else {
              numerr = 0
              this.stat = 1
              this.userTishi = ''
            }
          }
          if (this.$Bai(name)) {
            numerr = 1
            this.stat = 0
            return (this.EmailTiShi = 'please input email')
          }
          if (this.$Space(name)) {
            numerr = 1
            this.stat = 0
            return (this.EmailTiShi = 'Emailbox cannot contain spaces')
          }
          if (!this.$base(name, 'email')) {
            numerr = 1
            this.stat = 0
            return (this.EmailTiShi = 'please input a valid email')
          } else {
            numerr = 0
            this.stat = 1
            this.EmailTiShi = ''
          }
        } else if (this.types == 2) {
          if (this.$Bai(name)) {
            numerr = 1
            this.stat = 0
            return (this.phoneTiShi = 'Please enter phone number')
          }
          if (this.$Space(name)) {
            numerr = 1
            this.stat = 0
            return (this.phoneTiShi = 'phone number cannot contain spaces')
          }
          if (!this.$base(name, 'phone')) {
            numerr = 1
            this.stat = 0
            return (this.phoneTiShi = 'please enter a valid phone number')
          } else {
            numerr = 0
            this.stat = 1
            this.phoneTiShi = ''
          }
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return
      }
      //验证email和手机是否注册过
      let res = await this.$store.dispatch('_getRegDeteCt', {
        Account: name,
        Type: Type,
      })
      if (res.data.IsSuccess) {
        if (res.data.ItemCount == 0) {
          if (this.type == 1 && str == 'phone') {
            return (this.stat = 1)
          }
          if (Type == 0) {
            this.user_type = 1
          } else {
            this.user_type = Type
          }
          this.$store
            .dispatch('_getRegSendCode', {
              MobileEmail: name,
              CRCeMethod: this.user_type,
            })
            .then((res) => {
              if (res.data.IsSuccess) {
                this.status = 1
                this.timeCode(elem.target)
                localStorage.setItem(
                  'forgotStaTime',
                  parseInt(new Date().getTime() / 1000)
                )
                localStorage.setItem('forgotStaTimeType', this.user_type)
                localStorage.setItem(
                  'forgotTemporaryPhoneEmail',
                  this.form.name
                )
              }
            })
        } else {
          if (str == 'phone') {
            this.stat = 0
            this.userTishi =
              'The account number have been registered. You can input Verification code to retrieve If the account number is your account number confidently. '
          } else {
            this.status = 2
            this.statuCf = true
          }
        }
      }
    },
    timeCode(str) {
      //验证码时间定时器
      time = setInterval(() => {
        if (this.wait == 0) {
          this.Btn = 'Resend code'
          this.wait = 60
          clearInterval(time)
        } else {
          this.Btn = 'V Code(' + this.wait + ')'
          this.wait--
        }
      }, 1000)
    },
    submit() {
      //提交
      let status = 0
      if (this.$Bai(this.form.yzcode)) {
        status = 1
        this.codeTishi = 'verification code must be filled'
      } else if (this.form.yzcode.length != 6) {
        status = 1
        this.codeTishi = 'Please enter a six-digit verification code'
      }
      if (this.$Bai(this.form.pass)) {
        status = 1
        this.pwdTiShi = 'Password must input'
      } else if (this.$Space(this.form.pass)) {
        status = 1
        this.pwdTiShi = 'Password cannot contain spaces'
      } else if (this.$base(this.form.pass, 'aff')) {
        status = 1
        this.pwdTiShi = 'Illegal characters found in password'
      } else if (!this.$base(this.form.pass, 'pass')) {
        status = 1
        this.pwdTiShi =
          'The password must be set to 8~16 letters, numbers and special characters .!@#_ Combination'
      }
      if (this.$Bai(this.form.rpass)) {
        status = 1
        this.rpwdTiShi = 'Password must input'
      } else if (this.form.rpass.length < 8) {
        this.rpwdTiShi = 'Not less than 8 characters'
      } else if (this.$base(this.form.rpass, 'aff')) {
        status = 1
        this.rpwdTiShi = 'Illegal characters found in password'
      } else if (this.$Space(this.form.rpass)) {
        status = 1
        this.rpwdTiShi = 'Password cannot contain spaces'
      } else if (this.form.rpass != this.form.pass) {
        status = 1
        this.rpwdTiShi = 'The two passwords are not the same'
      }
      if (status == 1) {
        return
      }
      this.phoneTiShi = ''
      this.pwdTiShi = ''
      this.rpwdTiShi = ''
      this.EmailTiShi = ''
      this.codeTishi = ''
      let pwm = md5(this.form.pass + '!@*Samson*@!')
      let pwaes = CryptoJS.AES.encrypt(this.form.pass, pwm).toString()
      let data = {}
      if (this.type == 1) {
        data = {
          EmailBox: this.form.name,
          UserName: this.form.user,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode,
          Pwd: pwm,
        }
      } else if (this.type == 2) {
        data = {
          EmailBox: this.form.name,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode,
          Pwd: pwm,
        }
      } else {
        data = {
          Mobile: this.form.name,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode,
          Pwd: pwm,
        }
      }
      this.$store
        .dispatch('_postRegist', data)
        .then((res) => {
          if (res.data.IsSuccess) {
            sessionStorage.setItem('text', 1)
            alert('registration success')
            this.showsuess = true
            window.sessionStorage.setItem('Login', 1)
            this.$router.push('/Login')
          } else {
            alert(this.$CHEn.CH_EN(res.data.Message))
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      var random_number = Math.floor(Math.random() * (100 + 1))
      let res = await this.$store.dispatch('_getVerificationcode', {
        GUID: '',
        random: random_number,
      })
      if (res.data.IsSuccess) {
        this.GUID = res.data.Data.GUID
      } else {
        alert('Network Error')
      }
    },
  },
  emits: ['func', 'fuab'],
}
</script>

<style scoped>
.el-button--primary.is-plain {
  color: #fff;
}
.el-input__inner {
  width: auto;
}
.regist label {
  text-align: right !important;
}
.el-form-item__label {
  text-align: right !important;
}
.table-list {
  padding: 0 5px;
}
@media (max-width: 990px) {
  .regist label {
    text-align: right !important;
  }
}
@media (max-width: 768px) {
  .myzm {
    margin-left: 0;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1024px) {
  .el-col-md-8 {
    width: 53.33333% !important;
  }
}
</style>
